import { joinPathsStringUtil } from 'utils/string/index.js'

export const STRIPE_DOMAIN_NAME = 'stripe'

export const STRIPE_KEY = {
  IS_FORM_COMPLETE: 'isFormComplete',
  SHOULD_CREATE_TOKEN: 'shouldCreateToken',
  SHOULD_FOCUS_CARD_ELEMENT: 'shouldFocusCardElement',
  IS_CREATING_TOKEN: 'isCreatingToken',
  IS_SUBSCRIBING: 'isSubscribing',
  TOKEN_ID: 'tokenId'
}

export const STRIPE_STATE = {
  [STRIPE_KEY.IS_FORM_COMPLETE]: null,
  [STRIPE_KEY.SHOULD_CREATE_TOKEN]: null,
  [STRIPE_KEY.SHOULD_FOCUS_CARD_ELEMENT]: null,
  [STRIPE_KEY.IS_CREATING_TOKEN]: null,
  [STRIPE_KEY.IS_SUBSCRIBING]: null,
  [STRIPE_KEY.TOKEN_ID]: null
}

export const STRIPE_PATH = {
  [STRIPE_KEY.IS_FORM_COMPLETE]: joinPathsStringUtil(STRIPE_DOMAIN_NAME, STRIPE_KEY.IS_FORM_COMPLETE),
  [STRIPE_KEY.SHOULD_CREATE_TOKEN]: joinPathsStringUtil(STRIPE_DOMAIN_NAME, STRIPE_KEY.SHOULD_CREATE_TOKEN),
  [STRIPE_KEY.SHOULD_FOCUS_CARD_ELEMENT]: joinPathsStringUtil(STRIPE_DOMAIN_NAME, STRIPE_KEY.SHOULD_FOCUS_CARD_ELEMENT),
  [STRIPE_KEY.IS_CREATING_TOKEN]: joinPathsStringUtil(STRIPE_DOMAIN_NAME, STRIPE_KEY.IS_CREATING_TOKEN),
  [STRIPE_KEY.IS_SUBSCRIBING]: joinPathsStringUtil(STRIPE_DOMAIN_NAME, STRIPE_KEY.IS_SUBSCRIBING),
  [STRIPE_KEY.TOKEN_ID]: joinPathsStringUtil(STRIPE_DOMAIN_NAME, STRIPE_KEY.TOKEN_ID)
}
